import { EditPencil, Metadata, Trash } from '@assets/icons';
import { UserPermissions } from '@enums/user-permissions';

import { ContentModalActionType } from './types';

export const LABEL_ACTION_MAP = [
  {
    action: ContentModalActionType.EDIT_LABEL,
    label: 'Edit label',
    Icon: EditPencil,
    permission: UserPermissions.MANAGE_BRAND_LIBRARY,
  },
  {
    action: ContentModalActionType.LABEL_METADATA,
    label: 'Metadata',
    Icon: Metadata,
  },
  {
    action: ContentModalActionType.DELETE_LABEL,
    label: 'Delete',
    Icon: Trash,
    permission: UserPermissions.MANAGE_BRAND_LIBRARY,
  },
];

export const NO_ACCESS_DISABLED_TEXT =
  // eslint-disable-next-line quotes
  "You don't have access. Kindly contact your admin.";
